// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"901aee19","85":"20acca23","604":"fe4d0ff6","746":"f0ad6847","977":"ddc3fb4d"}[chunkId] + ".chunk.css";
};